import React from "react";
import LectureInfoCard from "./LectureInfoCard";
import QuickActionsCard from "./QuickActionsCard";
import { LectureData } from "./LectureTypes";

interface DetailsTabProps {
  lecture?: LectureData;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ lecture = {} }) => {
  return (
    <div>
      <style>{`
        .details-grid-container {
          display: grid;
          grid-template-columns: 1.6fr 1fr;
          gap: 24px;
          align-items: start;
        }

        .info-card-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px;
          border-bottom: 1px solid #f1f5f9;
        }
        .info-card-item:last-child {
          border-bottom: none;
        }

        .quick-action-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .quick-action-btn {
          background-color: #f4f9f9;
          border: 1px solid #e0f2f1;
          border-radius: 12px;
          padding: 20px 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          cursor: pointer;
          transition: all 0.15s ease;
          width: 100%;
          outline: none;
        }
        .quick-action-btn:hover {
          background-color: #e0f2f1;
          transform: translateY(-1px);
        }
        .quick-action-btn:focus-visible {
          outline: 2px solid #00b0f5;
        }

        .lecture-info-card { order: 1; }
        .quick-actions-card { order: 2; }

        @media (max-width: 768px) {
          .details-grid-container {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .lecture-info-card { order: 2; }
          .quick-actions-card { order: 1; }

          .quick-action-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 8px;
          }
          .quick-action-btn {
            padding: 14px 6px;
          }
        }
      `}</style>

      <div className="details-grid-container">
        <LectureInfoCard lecture={lecture} />
        <QuickActionsCard lecture={lecture} />
      </div>
    </div>
  );
};

export default DetailsTab;
